import { connectSocket, disconnectSocket } from './socket';

let started = false;
let socketRef = null;
let handlersRef = null;

export function startReportsRealtime() {
  if (started) return;
  started = true;

  const socket = connectSocket();
  socketRef = socket;

  const notifyRefresh = () => {
    try {
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event('reports:refresh'));
        window.dispatchEvent(new Event('badges:refresh'));
      }
    } catch {
      // ignore
    }
  };

  handlersRef = {
    created: notifyRefresh,
    updated: notifyRefresh,
    deleted: notifyRefresh,
    createdMine: notifyRefresh,
    updatedMine: notifyRefresh,
    deletedMine: notifyRefresh,
  };

  socket.on('report:created', handlersRef.created);
  socket.on('report:updated', handlersRef.updated);
  socket.on('report:deleted', handlersRef.deleted);

  socket.on('report:created:mine', handlersRef.createdMine);
  socket.on('report:updated:mine', handlersRef.updatedMine);
  socket.on('report:deleted:mine', handlersRef.deletedMine);
}

export function stopReportsRealtime() {
  if (!started) return;
  started = false;

  const socket = socketRef;
  const h = handlersRef;
  socketRef = null;
  handlersRef = null;

  if (socket && h) {
    try {
      socket.off('report:created', h.created);
      socket.off('report:updated', h.updated);
      socket.off('report:deleted', h.deleted);

      socket.off('report:created:mine', h.createdMine);
      socket.off('report:updated:mine', h.updatedMine);
      socket.off('report:deleted:mine', h.deletedMine);
    } catch {
      // ignore
    }
  }

  disconnectSocket();
}
